export default "__VITE_ASSET__BE92Lw0J__"